import {AxiosRequestConfig} from "axios";
import {configNew} from "../../../config";
import axios from "../../../api/axios";

const config = (): AxiosRequestConfig => {
  return {
    ...configNew()
  }
}

export const apiGetScreeningTestsList = (body: any) => axios.get(`/test/list`,
  {
    params: body,
    ...config()
  }).then(({data}) => data);

export const apiGetScreeningEarlyTestsList = (body: any) => axios.get(`/test/list`,
    {
      params: body,
      ...config()
    }).then(({data}) => data);


export const apiGetScreeningOneTest = (body: any) => axios.post(`/test/questions-list`, body, config())
  .then(({data}) => data);

export const apiGetScreeningRotinesTest = (body: any) => axios.get(`/test/surveys-list`,
    {
      params: body,
      ...config()
    }).then(({data}) => data);

export const apiPostScreeningOneTest = (body: any) => axios.post("test/evaluate-screening", body, config())
  .then(({data}) => data);

export const apiPostScreeningOneEarlyTest = (body: any) => axios.post("test/evaluate-screening", body, config())
  .then(({data}) => data);

export const apiPostScreeningEarlyQuestionsList = (body: any) => axios.post(`/test/questions-list`, body, config())
  .then(({data}) => data);